export default __webpack_public_path__ + "images/387c51b60bd71c81c6a7dd567eb76871.svg";